import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography } from "@mui/material";

import AppStoreIcon from "../Icons/AppStoreIcon";
import GooglePlayIcon from "../Icons/GooglePlayIcon";

import { AppStoreButton } from "./styles";
import TypographyLink from "../TypographyLink";

const DownloadAppSection = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="8px">
      <Typography color="white">{t("footer.download_our_app")}</Typography>
      <Stack direction="row" gap="16px">
        <AppStoreButton>
          <GooglePlayIcon />
          <TypographyLink href="https://play.google.com/store/apps/details?id=com.crossborderxpress.app&hl=es_419&gl=US" color="white" variant="body2">
            {t("footer.available_in")}
            <br />
            <strong>{t("footer.google_play")}</strong>
          </TypographyLink>
        </AppStoreButton>
        <AppStoreButton>
          <AppStoreIcon />
          <TypographyLink href="https://apps.apple.com/us/app/cross-border-xpress/id1528607079" color="white" variant="body2">
            {t("footer.available_in")}
            <br />
            <strong>{t("footer.app_store")}</strong>
          </TypographyLink>
        </AppStoreButton>
      </Stack>
    </Stack>
  );
};

export default DownloadAppSection;
